import {
  initialState,
  Actions,
  State,
  EXIST_DISCOUNT,
  EXIST_DISCOUNT_SUCCESS,
  EXIST_DISCOUNT_ERROR,
  RESET_EXIST_DISCOUNT
} from "../../types/discount/exist-discount";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EXIST_DISCOUNT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case EXIST_DISCOUNT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case EXIST_DISCOUNT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_EXIST_DISCOUNT:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
